import { render, staticRenderFns } from "./departmentdetail.vue?vue&type=template&id=db29030a"
import script from "./departmentdetail.vue?vue&type=script&lang=js"
export * from "./departmentdetail.vue?vue&type=script&lang=js"
import style0 from "./departmentdetail.vue?vue&type=style&index=0&id=db29030a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports